import React from 'react';
import { Blog } from '../../../types/schema';
import { Button } from '../../../styles/Button';
import Banner from '../../ui/Banner';
import PostItem from '../../ui/PostItem';
import { AllBlogContainer, Content } from './styles';
import ClientComponent from '../../ui/ClientComponent/ClientComponent';

export type AllBlogPageTemplateProps = {
  sortedPosts: Blog[];
  language: string;
  pageSize: number;
  page: number;
  setPage: (page: number) => void;
  bannerImg: string;
};

const AllBlogPageTemplate: React.FC<AllBlogPageTemplateProps> = ({
  sortedPosts,
  language,
  pageSize,
  page,
  setPage,
  bannerImg,
}) => {
  const isEn = language === 'en';
  return (
    <Content>
      <Banner title="Blog" bannerImg={bannerImg} />
      <AllBlogContainer>
        <ul>
          {sortedPosts
            .slice(0, pageSize)
            .map(
              (post) =>
                post.publicationDate &&
                new Date(post.publicationDate) < new Date() && (
                  <PostItem key={post.slug} post={post} related={false} isEn={isEn} />
                ),
            )}
        </ul>
        {sortedPosts.length === 0 && (
          <p>
            {isEn
              ? `There are no blog posts at the moment, we will add content soon!`
              : `Não temos posts no blog no momento, mas teremos conteúdo em breve`}
          </p>
        )}
      </AllBlogContainer>
      {pageSize < sortedPosts.length && (
        <Button onClick={() => setPage(page + 1)}>{isEn ? 'See more' : 'Ver mais'}</Button>
      )}
    </Content>
  );
};

export default function AllBlogPageTemplateClient(props: AllBlogPageTemplateProps) {
  return (
    <ClientComponent>
      <AllBlogPageTemplate {...props} />
    </ClientComponent>
  );
}
